<template>
    <DataTable
            v-redirect-if-no-permission:TYPES
            :url="api.ACTIONS.NATIONALITIES"
            :fieldsHiddenMain='["deleted_at"]'
            :fieldsHiddenAdd='["created_at","deleted_at","updated_at","id"]'
            :fieldsDisabledEdit='["created_at","deleted_at","updated_at","id"]'
            :fieldsExtraAdd="{name : 'v-text-field'}"
            :titles="titles"
            :title="$t('drivers.nationalities.title')"/>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";

    export default {
        name: "Nationalities",
        title() { return this.$t("drivers.nationalities.title"); },
        components: {DataTable},
        computed: {
            titles() {
                return {
                    "id": "#",
                    "name": this.$t("common.name"),
                    "created_at": this.$t("drivers.nationalities.createdAt"),
                    "updated_at": this.$t("drivers.nationalities.updatedAt")

                }
            }
        }
    }
</script>

<style scoped>

</style>